import { render, staticRenderFns } from "./ExcelColumnMapper.vue?vue&type=template&id=976a7508&scoped=true&"
import script from "./ExcelColumnMapper.vue?vue&type=script&lang=js&"
export * from "./ExcelColumnMapper.vue?vue&type=script&lang=js&"
import style0 from "./ExcelColumnMapper.vue?vue&type=style&index=0&id=976a7508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976a7508",
  null
  
)

export default component.exports